module.exports = __webpack_public_path__ + "static/media/touchbase_logo2.9fe2a350.png";